import {
    GET_ANALYTICS_ERROR, GET_ANALYTICS_LOADING, GET_ANALYTICS_SUCCESS,
    GET_DAILY_ANALYTICS_ERROR, GET_DAILY_ANALYTICS_LOADING, GET_DAILY_ANALYTICS_SUCCESS,
    GET_MONTHLY_ANALYTICS_ERROR, GET_MONTHLY_ANALYTICS_LOADING, GET_MONTHLY_ANALYTICS_SUCCESS
} from "../../Action/Type";

const initialState = { payload: {}, loading: false, error: '' };

export const GetAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ANALYTICS_LOADING: return Object.assign({}, state, { loading: true });
        case GET_ANALYTICS_SUCCESS: return Object.assign({}, state, { payload: action.data, loading: false });
        case GET_ANALYTICS_ERROR:   return Object.assign({}, state, { payload: action.data, loading: false });
        default: return state;
    }
};

export const GetDailyAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DAILY_ANALYTICS_LOADING: return Object.assign({}, state, { loading: true });
        case GET_DAILY_ANALYTICS_SUCCESS: return Object.assign({}, state, { payload: action.data, loading: false });
        case GET_DAILY_ANALYTICS_ERROR:   return Object.assign({}, state, { payload: action.data, loading: false });
        default: return state;
    }
};

export const GetMonthlyAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MONTHLY_ANALYTICS_LOADING: return Object.assign({}, state, { loading: true });
        case GET_MONTHLY_ANALYTICS_SUCCESS: return Object.assign({}, state, { payload: action.data, loading: false });
        case GET_MONTHLY_ANALYTICS_ERROR:   return Object.assign({}, state, { payload: action.data, loading: false });
        default: return state;
    }
};
